class HeaderHidden {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    // $('.js-drawer').click(function () {
    //   $('.js-hidden').toggleClass('is-open');
    // });
  }
}
